import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { getJwt } from '@src/utils/localStorage'
import { captureError } from '../errors'

const requestTransform = (config: AxiosRequestConfig) => {
  const authToken = getJwt()

  if (authToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${authToken}`,
    }
  }
  return config
}

type PartialWith<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export const responseInterceptor = (response: AxiosResponse) => {
  // Not sure we need these inside of redux
  delete (response as PartialWith<AxiosResponse, 'config'>).config
  delete response.request
  return response
}

export const responseErrorInterceptor = (error: AxiosError) => {
  if (error.response) {
    if (error.response.status >= 500) {
      captureError(new Error(error.response.data.statusText))
    }
    delete (error.response as PartialWith<AxiosResponse<any>, 'config'>).config
    delete error.response.request
    delete (error as PartialWith<AxiosError, 'message'>).message
  }
  // Throw the exception since we may want to handle this exception in our code
  throw error
}

export const createAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
  })

  instance.interceptors.request.use(requestTransform)

  instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor)
  return instance
}



// WEBPACK FOOTER //
// ./src/utils/http-clients/baseAxiosInstance.ts